import { useEffect, useState } from 'react';
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import { Search } from 'lucide-react';
import api from '../../../lib/api';

export const CustomerPicker = ({ onPick }) => {
  const [q, setQ] = useState('');
  const [rows, setRows] = useState([]);
  useEffect(() => {
    if (q.trim().length < 2) { setRows([]); return undefined; }
    const t = setTimeout(() => {
      api.get('/patients/autocomplete', { params: { q } }).then(r => setRows(r.data.results || [])).catch(() => setRows([]));
    }, 250);
    return () => clearTimeout(t);
  }, [q]);
  return (
    <div className="space-y-1.5" data-testid="ctrl-customer-picker">
      <Label className="text-xs">Find the customer's saved record *</Label>
      <div className="relative">
        <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Name or phone" className="pl-8" data-testid="ctrl-customer-search" />
      </div>
      {rows.length > 0 && (
        <div className="max-h-40 overflow-y-auto rounded-md border divide-y">
          {rows.map((p) => (
            <button key={p.patient_id} type="button" onClick={() => onPick(p.patient_id)} data-testid={`ctrl-customer-${p.patient_id}`}
              className="w-full text-left px-3 py-2 text-sm hover:bg-muted transition-colors">
              {p.name}<span className="text-xs text-muted-foreground ml-2">{p.phone}</span>
            </button>
          ))}
        </div>
      )}
      <p className="text-[11px] text-muted-foreground">No record yet? Add the customer in Customers first — controlled drugs need a saved record.</p>
    </div>
  );
};
